enum PurchaseOrderLineAdjustmentType {
  ADD = "ADD",
  PARTIAL_REMOVE = "PARTIAL_REMOVE",
  CANCEL = "CANCEL"
}

export default PurchaseOrderLineAdjustmentType;
